module.exports = __webpack_public_path__ + "img/guide_pic.4a1a89f6.png";